<template>
  <div class="help">
    <h1>This is a help page</h1>
  </div>
</template>

<script>
export default {
  name: 'help'
}
</script>
